import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class PriceListQueryFilter extends QueryFilter{
    public organizationId: string;
  }
  